module.exports = __webpack_public_path__ + "static/home-quick-b6e1bc6458cfa3f3de30d4ba5b362e72.svg";